var map = {
	"./age.png": 5455,
	"./category.png": 5161,
	"./dolar.png": 1543,
	"./facebook.png": 4303,
	"./google.png": 2116,
	"./instagram.png": 8709,
	"./linkedin.png": 8533,
	"./ok.png": 2750,
	"./pinterest.png": 5261,
	"./stats.png": 1944,
	"./twitter.png": 2493,
	"./whatsapp.png": 6665,
	"./youtube.png": 4906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;